import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SlickCarouselComponent } from 'ngx-slick-carousel';

@Component({
  selector: 'our-services',
  templateUrl: './our-services.component.html',
  styleUrls: ['./our-services.component.css']
})
export class OurServicesComponent implements OnInit {

  @ViewChild('slickModal') slickModal: SlickCarouselComponent;

  
  slides = [
    {img: "./../../../assets/images/cars.png", title: this.translateService.instant("design compony's website")},
    {img: "./../../../assets/images/decor.png", title: this.translateService.instant("design furniture's website")},
    {img: "./../../../assets/images/furinture.png", title: this.translateService.instant("fairs and deliveries managment system")},
    {img: "./../../../assets/images/law.png", title: this.translateService.instant("law firm website")},
    {img: "./../../../assets/images/medical.png", title: this.translateService.instant("design medical or hospital website")},
    {img: "./../../../assets/images/school.png", title: this.translateService.instant("design academy or school website")}
  ];

  offers = [
    {title: this.translateService.instant("design compony's website"), img: "./../../../assets/images/tabletcar.png", desc: this.translateService.instant("If you have a company, then of course you need a website to develop your business and follow up on reservations for offers and raise the level of your company. You need a website with a professional design that dazzles the visitor when entering it and reflects the extent of the professionalism of this company, and thus leaves the opportunity for your site to market your services for you without any effort on your part. We provide You offer a website design, and we understand very well your requirements and the requirements of your visitors and customers on this site,")},
    {title: this.translateService.instant("design furniture's website"), img: "./../../../assets/images/tabletdecor.png", desc: this.translateService.instant("Do you have a dream of owning a company that will earn you millions and make you one of the top businessmen?")},
    {title: this.translateService.instant("fairs and deliveries managment system"), img: "./../../../assets/images/tabletfurnutire.png", desc: this.translateService.instant("We offer you an integrated system to manage your showroom, your delegates, and your distribution points, with specifying the locations of the delegates, knowing the accounts of your exhibition, determining your daily, weekly and monthly sales, identifying your best customers and the best delegates, and we also determine the gains and losses achieved from sales for each")},
    {title: this.translateService.instant("law firm website"), img: "./../../../assets/images/tabletlaw.png", desc: this.translateService.instant("If you have a company or office that provides special services or consultations, if you are a lawyer, engineer, chartered accountant, etc., and you have a private office and you want a simple website that displays your services or products, expands your customer base and increases your profits, and displays information and contact information for your company or office, and visitors can To contact you and communicate with you through the site, if you want a website that contributes to increasing the number of customers you have, we offer you a company website design proposal, to contribute to the development of your business and add more success to your business")},
    {title: this.translateService.instant("design medical or hospital website"), img: "./../../../assets/images/tabletdoctor.png", desc: this.translateService.instant("If you have a hospital or one of the general or specialized medical centers or a clinic, and you want to create a website that displays the medical services that you provide, and also displays the medical features that you provide, and displays well, clearly and with pictures the departments inside your hospital or medical center, and if you also want to Visitors make medical reservations through the hospital or medical center website. We offer you a hospital website design offer, where we contribute with you to the development of your management of your hospital, medical center, or clinic.")},
    {title: this.translateService.instant("design academy or school website"), img: "./../../../assets/images/tabletschool.png", desc: this.translateService.instant("If you have a school, university, educational institute or academy and you want to improve the educational process and use the latest means and technologies in communicating with students and parents to add to you a competitive advantage between schools or other educational institutes, and therefore you are thinking of creating a site that serves as the main destination for the school on the Internet, which It contributes to the development of the school's performance and makes it keep pace with technological development. We offer you a school design offer, to provide you with technical solutions to develop the performance of the school administration, university, institute or academy.")},
  ];

  slideConfig = {
    speed: 300,
    dots: false,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.carousel-desc',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]    
  };

  slideConfigDesc = {
    speed: 300,
    dots: false,
    infinite: true,
    slidesToShow: 1,
    asNavFor: '.carousel',
    arrows: false
  };  
  constructor(private translateService : TranslateService) { }
    navigateToindex($event){
console.log($event)
this.slickModal.slickGoTo($event ) 
    }
  ngOnInit(): void {
  }

}
